import {MolecularGraph} from "../../graph/MolecularGraph"
import {Feature, Features} from "../../feature";
import {extractorUtil} from "../../util/extractorUtil";

export const nitroExtractor = {
    extract: (graph: MolecularGraph) => {
        // Nitro groups are rooted at a positively charged N with connections to a double bonded O and a single
        // bond to a negatively charged O
        const features: Feature[] = [];
        const nitrogenRoots = extractorUtil.getFunctionalGroupRootsWithElement("N", graph)
        nitrogenRoots.forEach(nitrogen => {
            if (nitrogen.charge === 1) {
                const singleBondedOs = extractorUtil.getSingleBondsToO(nitrogen, graph).map(b => b.getOtherAtom(nitrogen));
                const doubleBondedOs = extractorUtil.getDoubleBondsToO(nitrogen, graph).map(b => b.getOtherAtom(nitrogen));
                if (singleBondedOs.length === 1 && doubleBondedOs.length === 1) {
                    const singleBondedO = singleBondedOs[0];
                    const doubleBondedO = doubleBondedOs[0];

                    const hasCorrectLps = singleBondedO.lonePairs === 3 && doubleBondedO.lonePairs === 2;
                    if(singleBondedO.charge === -1 && hasCorrectLps) {
                        const name = Features.nitro;
                        const atoms = [
                            nitrogen,
                            doubleBondedO,
                            singleBondedO
                        ]

                        const externalBonds = extractorUtil.getExternalBonds(atoms, graph);
                        const externalAtoms = externalBonds.map(b => [b.a1, b.a2]).flat();
                        const connections = externalAtoms.filter(a => !atoms.includes(a));
                        features.push({name, atoms, connections});
                    }
                }
            }
        })
        return features;
    }
}
